import { List, fromJS } from 'immutable';
import { RestAPI } from '@/util/net.js';
import { putError } from '@/store/error.store';

export const todaysPaymentsReducer = (state = new List(), action) => {
  switch (action.type) {
    case 'CLEAR_TODAYS_PAYMENTS':
      return new List();
    case 'TODAYS_PAYMENTS_LOADED':
      return fromJS(action.data);
    default:
      return state;
  }
};

export const clearTodaysPayments = (dispatch) => {
  dispatch({ type: 'CLEAR_TODAYS_PAYMENTS' });
};

export const generateReport = (dispatch, bank) => {
  dispatch({ type: 'LOADING_TODAYS_PAYMENTS' });
  return RestAPI.get(`/deals/payments/api/todaysPayments?bankId=${bank || ''}`)
    .then(
      (data) => {
        dispatch({ type: 'TODAYS_PAYMENTS_LOADED', data });
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'TODAYS_PAYMENTS_LOADING_FAILED' });
        return true;
      },
    );
};
